import $ from "jquery";

$.validator.addMethod("emailex", function(value, element, parameters) {
    if (value === "") {
        return true;
    }
    
    const regex = new RegExp($(element).data("val-emailex-regex"));

    return regex.test(value);
});

$.validator.unobtrusive.adapters.add("emailex", ["dependentproperty"], function(options) {
    options.rules.emailex = options.params;
    options.messages.emailex = options.message;
});